import { FilesPanel as Panel, type FilesPanelProps as PanelProps } from '@genieartinc/studio-ui'
import { useUserLoras } from '@/hooks/useUserLoras'
import { ModelsTabContent } from './models-tab-content'
export type FilesPanelProps = Omit<PanelProps, 'modelCount' | 'modelsContent'>
export function FilesPanel(props: FilesPanelProps) {
  const models = useUserLoras()
  return <Panel {...props} modelCount={models.models.length} modelsContent={<ModelsTabContent {...models} />} />
}
